import { AfterViewInit, Component, Inject, NgZone, OnInit, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { fromEvent, Observable } from 'rxjs';
import { map, pairwise, throttleTime } from 'rxjs/operators';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { WINDOW } from '@ng-web-apis/common';
import { AppStateService } from '@fb-tool-front/core/services';
import { ResizeObserverDirective } from '@ng-web-apis/resize-observer';

@UntilDestroy()
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements AfterViewInit, OnInit {
  readonly HIDE_SCROLL = 250;

  @ViewChild(ToolbarComponent)
  toolbar: ToolbarComponent;

  @ViewChild('toolbarResize', { static: true, read: ResizeObserverDirective })
  toolbarResize: ResizeObserverDirective;

  isNightTheme$: Observable<boolean>;

  constructor(
    private zone: NgZone,
    @Inject(WINDOW) readonly windowRef: Window,
    private appStateService: AppStateService
  ) {}

  ngOnInit(): void {
    this.isNightTheme$ = this.appStateService.isNightTheme$;
  }

  ngAfterViewInit() {
    const nativeToolbar: HTMLElement = this.toolbar?.elementRef?.nativeElement;

    if (!nativeToolbar) {
      return;
    }

    this.zone.runOutsideAngular(() => {
      fromEvent(this.windowRef, 'scroll')
        .pipe(
          map(_ => this.windowRef.pageYOffset),
          throttleTime(100, undefined, { trailing: true }),
          pairwise(),
          untilDestroyed(this)
        )
        .subscribe(([prev, curr]) => {
          if (curr > 0) {
            nativeToolbar.classList.add('active-toolbar');
          } else {
            nativeToolbar.classList.remove('active-toolbar');
          }

          if (prev !== undefined && prev > curr) {
            nativeToolbar.classList.remove('hide-toolbar');
          }

          if (prev !== undefined && curr >= this.HIDE_SCROLL && prev <= curr) {
            nativeToolbar.classList.add('hide-toolbar');
          }
        });
    });
  }
}
